// extracted by mini-css-extract-plugin
export default {"modal":"dispatch-tickets-list_modal__3tX+o"};